import i18n from '~/i18n'

export const ERRORS = {
  EMPTY: i18n.t('c:components.TagInput.alert.insertAtLeastOneEntry'),
  DUPLICATED: i18n.t('c:components.TagInput.alert.termAlreadyAdded')
}

export const validateInput = ({
  inputValues,
  tags
}: {
  inputValues: string[]
  tags: string[]
}) => {
  const errors: string[] = []

  const isEmpty = !inputValues?.length

  if (isEmpty) {
    errors.push(ERRORS.EMPTY)
  }

  const isDuplicated =
    inputValues.length === 1 &&
    tags.some(item => inputValues[0].toLowerCase() === item.toLowerCase())

  if (isDuplicated) {
    errors.push(ERRORS.DUPLICATED)
  }

  return errors
}

export const splitTerms = (inputValue: string): string[] => {
  return inputValue
    .toString()
    .replaceAll(';', '\n')
    .replaceAll('\r\n', '\n')
    .split('\n')
    .filter(item => !!item.trim())
    .map(item => item.trim())
}

export const cleanArray = (splitTerms: string[]): string[] => {
  return [...new Set(splitTerms)]
}

export const keywordsStringToCleanArray = (inputValue: string) => {
  return cleanArray(splitTerms(inputValue))
}
